import React, { useState } from 'react';
import { Switch, useRouteMatch, Link, Route } from 'react-router-dom';
import { Layout } from './Layout';


const MobileDevelopment = () => {

    let { path, url } = useRouteMatch();

    return (

        <div className="mobile main-content">

        <Layout>
            <div className="">

                <h1>Cross platform Mobile development</h1>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Adipiscing elit duis tristique sollicitudin nibh sit amet commodo. Sem nulla pharetra diam sit amet nisl suscipit adipiscing. Condimentum lacinia quis vel eros donec ac odio tempor. Et tortor consequat id porta nibh. Laoreet non curabitur gravida arcu ac tortor. Potenti nullam ac tortor vitae purus faucibus. Libero enim sed faucibus turpis. Magna fermentum iaculis eu non diam phasellus vestibulum lorem. Vel facilisis volutpat est velit egestas. Egestas tellus rutrum tellus pellentesque eu tincidunt. Sed felis eget velit aliquet sagittis id consectetur purus. Tortor posuere ac ut consequat. Aliquam sem fringilla ut morbi tincidunt augue. Pulvinar neque laoreet suspendisse interdum consectetur. Felis eget velit aliquet sagittis id consectetur purus ut. Amet porttitor eget dolor morbi non arcu risus quis varius. Aliquet bibendum enim facilisis gravida neque convallis. Id donec ultrices tincidunt arcu non sodales. Dolor sit amet consectetur adipiscing elit duis tristique sollicitudin.</p>


                <Switch>
                    <Route exact path={path}>

                    </Route>
                    <Route path={`${path}/mesh`}>
                        <Layout>
                        </Layout>
                    </Route>
                    <Route path={`${path}/rcferret`}>
                        <Layout>
                        </Layout>
                    </Route>
                </Switch>



            </div>
            <div/>
        </Layout>


        <h1>Case studies</h1>
        <div className="services">
                <div>
                    <h2>MOT Checker</h2>
                    <p></p>
                </div>

            <div>
                <h2>Mesh App</h2>
                <p></p>
            </div>

            <div>
                <h2>RC Ferret</h2>
                <p></p>
            </div>

        </div>

        </div>

    );
};


const MotChecker = () => {

}

export default MobileDevelopment;